import { axiosClient } from "./axiosClient";

export interface InteractionLogDto {
    id: number;
    fileName: string;
    content: string;
}

// GET all logs
export const getInteractionLogs = async () => {
    return await axiosClient.get<InteractionLogDto[]>("/InteractionLog");
};

// GET by Id
export const getInteractionLogById = async (id: number) => {
    return await axiosClient.get<InteractionLogDto>(`/InteractionLog/${id}`);
};

// CREATE
export const createInteractionLog = async (data: Omit<InteractionLogDto, "id">) => {
    return await axiosClient.post<InteractionLogDto>("/InteractionLog", data);
};

// DELETE
export const deleteInteractionLog = async (id: number) => {
    return await axiosClient.delete(`/InteractionLog/${id}`);
};
